'use client';

import { NavbarContent, NavbarItem } from '@heroui/navbar';
import { Popover, PopoverContent, PopoverTrigger } from '@heroui/popover';
import { Link } from '@heroui/link';
import { NextUI } from '@/components/NextUI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ToolMenu from '@/components/Layouts/Default/Partials/Navbar/NavbarToolMenu';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import {
  logHubxEvent,
  APP_EVENTS,
} from '@/lib/analytics/services/log-hubx-event';

const NavbarTools = () => {
  const translate = useTranslations();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <NavbarContent className="flex-1 [&_a]:navbar-link gap-8">
      <NavbarItem>
        <Popover
          isOpen={isOpen}
          onOpenChange={(open) => setIsOpen(open)}
          placement="bottom"
          shouldBlockScroll
          offset={30}
        >
          <PopoverTrigger>
            <NextUI.Button
              data-hover={isOpen}
              disableAnimation
              variant="link"
              className="font-normal !flex !items-center hover:!text-primary-dark-blue"
              onClick={() =>
                logHubxEvent({
                  eventName: APP_EVENTS.BTN_HEADER,
                  source: 'all_tools',
                })
              }
            >
              <FontAwesomeIcon icon={['fas', 'grip']} />
              {translate('navbar.all_tools')}
              <FontAwesomeIcon icon={['fas', 'chevron-down']} size="2xs" />
            </NextUI.Button>
          </PopoverTrigger>
          <PopoverContent className="p-0 shadow-none border !border-gray-medium2 !rounded-extra-lg bg-white !w-[calc(100vw-25px)]">
            <ToolMenu />
          </PopoverContent>
        </Popover>
      </NavbarItem>
      <NavbarItem className="hidden xl:block">
        <Link
          href="/compress"
          className="hover:!text-primary-dark-blue !font-normal"
          onClick={() =>
            logHubxEvent({
              eventName: APP_EVENTS.BTN_HEADER,
              source: 'compress',
            })
          }
        >
          {translate('navbar.compress')}
        </Link>
      </NavbarItem>
      <NavbarItem className="hidden xl:block">
        <Link
          href="/pdf-converter"
          className="hover:!text-primary-dark-blue !font-normal"
          onClick={() =>
            logHubxEvent({
              eventName: APP_EVENTS.BTN_HEADER,
              source: 'convert',
            })
          }
        >
          {translate('navbar.convert')}
        </Link>
      </NavbarItem>
      <NavbarItem className="hidden xl:block">
        <Link
          href="/merge-pdf"
          className="hover:!text-primary-dark-blue !font-normal"
          onClick={() =>
            logHubxEvent({
              eventName: APP_EVENTS.BTN_HEADER,
              source: 'merge',
            })
          }
        >
          {translate('navbar.merge')}
        </Link>
      </NavbarItem>
      <NavbarItem className="hidden xl:block">
        <Link
          href="/pdf-editor"
          className="hover:!text-primary-dark-blue !font-normal"
          onClick={() =>
            logHubxEvent({
              eventName: APP_EVENTS.BTN_HEADER,
              source: 'edit',
            })
          }
        >
          {translate('navbar.edit')}
        </Link>
      </NavbarItem>
      <NavbarItem className="hidden xl:block">
        <Link
          href="/esign-pdf"
          className="hover:!text-primary-dark-blue !font-normal"
          onClick={() =>
            logHubxEvent({
              eventName: APP_EVENTS.BTN_HEADER,
              source: 'esign',
            })
          }
        >
          {translate('navbar.esign')}
        </Link>
      </NavbarItem>
    </NavbarContent>
  );
};

export default NavbarTools;
